export default __webpack_public_path__ + "static/media/twitter.bf36f3f6.svg";